import * as React from "react";
import { Accordeon, Tree } from "@focus/focusUI";
import "./VariableList.scss";
const createNode = (title, key, type) => (React.createElement("ul", null,
    React.createElement("li", null,
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { className: "var_list-row" },
                    React.createElement("td", { className: "var_list-name" },
                        " ",
                        React.createElement(Accordeon, { title: title })),
                    React.createElement("td", { className: "var_list-short" },
                        React.createElement("span", { style: { marginLeft: "10px" } }, key)),
                    React.createElement("td", { className: "var_list-type" },
                        React.createElement("span", { style: { marginLeft: "10px" } }, type))))))));
export class VariableList extends React.Component {
    constructor(props) {
        super(props);
        this.handleCollapse = (id) => {
            const collapsed = Object.assign({}, this.state.collapsed);
            collapsed[id] = !collapsed[id];
            this.setState({ collapsed });
        };
        this.expansionHandler = (node) => {
            if (node.childNodes.length > 0) {
                this.handleCollapse(node.id);
            }
        };
        let collapsed = [];
        Object.keys(flattenSchema(props.schema)).forEach((e) => {
            collapsed[e] = false;
        });
        collapsed["intervalStartNode"] = false;
        collapsed["intervalEndNode"] = false;
        this.state = {
            collapsed,
        };
    }
    getVariableListFromSchema(props) {
        return this.schemaToTree(props.schema.properties);
    }
    getChildNode(schema) {
        let childNodes;
        if (schema.legends !== undefined) {
            let item = {
                title: null,
                key: null,
                type: null,
            };
            let arrayItem = [];
            for (let i = 0; i < Object.keys(schema.legends).length; i++) {
                item = {
                    title: schema.legends[i],
                    key: i + 1,
                    type: schema.items.type,
                };
                arrayItem.push(item);
            }
            childNodes = this.schemaToTreeAux(arrayItem);
        }
        if (schema.items.properties !== undefined) {
            childNodes = this.schemaToTreeAux(schema.items.properties);
        }
        if (schema.columnlegends !== undefined) {
            let item = {
                title: null,
                key: null,
                type: null,
            };
            let item2 = {
                title: null,
                key: null,
                type: null,
            };
            let arrayItem = [];
            let arrayItem2 = [];
            for (let i = 0; i < Object.keys(schema.columnlegends).length; i++) {
                item = {
                    title: schema.columnlegends[i],
                    key: "Column",
                    type: schema.items.items.type,
                };
                arrayItem.push(item);
            }
            for (let i = 0; i < Object.keys(schema.rowlegends).length; i++) {
                item2 = {
                    title: schema.rowlegends[i],
                    key: "Row",
                    type: schema.items.items.type,
                };
                arrayItem2.push(item2);
            }
            childNodes = this.schemaToTreeAux(arrayItem);
            childNodes = childNodes.concat(this.schemaToTreeAux(arrayItem2));
        }
        return childNodes;
    }
    getEpochOptions(schema, type) {
        let nodes = [];
        schema.properties.modifier.enumNames.forEach((value, index) => {
            nodes.push({
                childNodes: [],
                hasCaret: false,
                isExpanded: false,
                id: value,
                label: createNode(value, schema.properties.modifier.enum[index], type.toUpperCase() + "_OPTION"),
            });
        });
        return nodes;
    }
    schemaToTreeAux(schema) {
        const res = [];
        Object.keys(schema).forEach((e) => {
            let childNodes = [];
            if (schema[e].type === "object") {
                childNodes = this.schemaToTreeAux(schema[e].properties);
            }
            if (schema[e].type === "array") {
                childNodes = this.getChildNode(schema[e]);
            }
            let type = schema[e]["type"];
            if (schema[e]["type"] === "string") {
                type = schema[e]["enum"] ? "menu" : type;
                if (schema[e]["enum"]) {
                    schema[e]["enum"].forEach((value, index) => {
                        childNodes.push({
                            childNodes: [],
                            hasCaret: false,
                            id: value,
                            isExpanded: false,
                            label: createNode(schema[e]["enumNames"][index], value, "MENU_KEY"),
                        });
                    });
                }
            }
            if (!type) {
                if (schema[e].properties !== undefined && schema[e].properties.start) {
                    type = "interval";
                    let intervalStartNode = this.getEpochOptions(schema[e].properties.start, type);
                    let intervalEndNode = this.getEpochOptions(schema[e].properties.end, type);
                    childNodes.push({
                        childNodes: intervalStartNode,
                        hasCaret: intervalStartNode.length > 0,
                        id: "intervalStartNode",
                        isExpanded: this.state.collapsed["intervalStartNode"],
                        label: createNode("Interval Start", schema[e]["key"], type),
                    });
                    childNodes.push({
                        childNodes: intervalEndNode,
                        hasCaret: intervalEndNode.length > 0,
                        id: "intervalEndNode",
                        isExpanded: this.state.collapsed["intervalEndNode"],
                        label: createNode("Interval End", schema[e]["key"], type),
                    });
                }
                else if (schema[e].properties !== undefined &&
                    schema[e].properties.modifier.enumNames !== undefined &&
                    schema[e].properties.modifier.enumNames.length > 0) {
                    type = "epoch";
                    let nodes = this.getEpochOptions(schema[e], type);
                    nodes.forEach((node) => {
                        childNodes.push(node);
                    });
                }
            }
            res.push({
                id: e,
                label: createNode(schema[e]["title"], schema[e]["key"], type),
                childNodes,
                isExpanded: this.state.collapsed[e],
                hasCaret: childNodes.length > 0,
            });
        });
        return res;
    }
    schemaToTree(schema) {
        let tree = [];
        Object.keys(schema).forEach((e) => {
            let childNodes = [];
            if (schema[e].type === "object") {
                childNodes = this.schemaToTreeAux(schema[e].properties);
            }
            if (schema[e].type === "array") {
                childNodes = this.getChildNode(schema[e]);
            }
            let type = schema[e]["type"];
            if (schema[e]["type"] === "string") {
                type = schema[e]["enum"] ? "menu" : type;
                if (schema[e]["enum"]) {
                    schema[e]["enum"].forEach((value, index) => {
                        childNodes.push({
                            childNodes: [],
                            hasCaret: false,
                            id: value,
                            isExpanded: false,
                            label: createNode(schema[e]["enumNames"][index], value, "MENU_KEY"),
                        });
                    });
                }
            }
            if (!type) {
                if (schema[e].properties !== undefined && schema[e].properties.start) {
                    type = "interval";
                    let intervalStartNode = this.getEpochOptions(schema[e].properties.start, type);
                    let intervalEndNode = this.getEpochOptions(schema[e].properties.end, type);
                    childNodes.push({
                        childNodes: intervalStartNode,
                        hasCaret: intervalStartNode.length > 0,
                        id: "intervalStartNode",
                        isExpanded: this.state.collapsed["intervalStartNode"],
                        label: createNode("Interval Start", schema[e]["key"], type),
                    });
                    childNodes.push({
                        childNodes: intervalEndNode,
                        hasCaret: intervalEndNode.length > 0,
                        id: "intervalEndNode",
                        isExpanded: this.state.collapsed["intervalEndNode"],
                        label: createNode("Interval End", schema[e]["key"], type),
                    });
                }
                else if (schema[e].properties !== undefined &&
                    schema[e].properties.modifier.enumNames !== undefined &&
                    schema[e].properties.modifier.enumNames.length > 0) {
                    type = "epoch";
                    let nodes = this.getEpochOptions(schema[e], type);
                    nodes.forEach((node) => {
                        childNodes.push(node);
                    });
                }
            }
            tree.push({
                id: e,
                label: createNode(schema[e]["title"], schema[e]["key"], type),
                childNodes,
                isExpanded: this.state.collapsed[e],
                hasCaret: childNodes.length > 0,
            });
        });
        return tree;
    }
    render() {
        return (React.createElement("div", { style: {
                marginLeft: 30,
                overflow: "auto",
                height: "100%",
                width: "900px",
            }, className: "var_list-container" },
            React.createElement(Tree, { contents: this.getVariableListFromSchema(this.props), onNodeCollapse: (node) => this.expansionHandler(node), onNodeExpand: (node) => this.expansionHandler(node), onNodeClick: (node) => this.expansionHandler(node) })));
    }
}
function checkType(schema) {
    let type;
    if (schema.type === "array" && schema.items.properties !== undefined) {
        type = schema.items.properties;
    }
    if (schema.type === "array" && schema.columnlegends !== undefined) {
        type = schema.columnlegends;
    }
    if (schema.type === "array" && schema.legends !== undefined) {
        type = schema.legends;
    }
    return type;
}
function flattenArray(schema) {
    let flatSchema = {};
    if (schema.type === "object") {
        flatSchema = Object.assign({}, schema.properties);
        for (let i = 0; i < Object.keys(schema.properties).length; i++) {
            flatSchema[Object.keys(schema.properties)[i]] =
                schema.properties[Object.keys(schema.properties)[i]];
            if (schema.properties[Object.keys(schema.properties)[i]].type === "array" ||
                schema.properties[Object.keys(schema.properties)[i]].type === "object") {
                const temp = flattenArray(schema.properties[Object.keys(schema.properties)[i]]);
                flatSchema = Object.assign({}, temp, flatSchema);
            }
        }
    }
    else if (schema.type === "array") {
        const type = checkType(schema);
        for (let i = 0; i < Object.keys(type).length; i++) {
            flatSchema = Object.assign({}, type);
            flatSchema[Object.keys(type)[i]] = type[Object.keys(type)[i]];
            if (schema.type === "array" || schema.type === "object") {
                const temp = flattenArray(type[Object.keys(type)[i]]);
                flatSchema = Object.assign({}, temp, flatSchema);
            }
        }
    }
    return flatSchema;
}
function flattenSchema(schema) {
    const noArrays = flattenArray(schema);
    return noArrays;
}
//# sourceMappingURL=VariableList.js.map